import React from "react";
import { useState, useEffect, useRef } from "react";
import Product from "./product.svg";
import Resellers from "./Resellers.svg";
import BrandIcon from "./brandtalk.svg";

function Section1() {
  const timerIdRef = useRef(0);
  const [count, setCount] = useState(0);
  const previousCount = useRef(count);

  useEffect(
    function () {
      // const input = myRef.current;
      // input.focus();
      // checks if it has reach the max value
      if (previousCount.current >= 1491) {
        clearInterval(timerIdRef.current);
        return;
      }
      // sets the timerIdRef at component mount
      timerIdRef.current = setInterval(() => {
        setCount((prev) => ++prev);
        previousCount.current++;
      }, 0);

      // clears the interval at component unmount
      return function () {
        clearInterval(timerIdRef.current);
      };
    },
    [count]
  );

  const timerId1Ref = useRef(0);
  const [count1, setCount1] = useState(0);
  const previousCount1 = useRef(count1);
  useEffect(
    function () {
      // const input = myRef.current;
      // input.focus();
      // checks if it has reach the max value
      if (previousCount1.current >= 203) {
        clearInterval(timerId1Ref.current);
        return;
      }
      // sets the timerIdRef at component mount
      timerId1Ref.current = setInterval(() => {
        setCount1((prev) => ++prev);
        previousCount1.current++;
      }, 0);

      // clears the interval at component unmount
      return function () {
        clearInterval(timerId1Ref.current);
      };
    },
    [count1]
  );

  const timerId2Ref = useRef(0);
  const [count2, setCount2] = useState(0);
  const previousCount2 = useRef(count2);
  useEffect(
    function () {
      // const input = myRef.current;
      // input.focus();
      // checks if it has reach the max value
      if (previousCount2.current >= 243) {
        clearInterval(timerId2Ref.current);
        return;
      }
      // sets the timerIdRef at component mount
      timerId2Ref.current = setInterval(() => {
        setCount2((prev) => ++prev);
        previousCount2.current++;
      }, 0);

      // clears the interval at component unmount
      return function () {
        clearInterval(timerId2Ref.current);
      };
    },
    [count2]
  );

  return (
    <div className='bgi-no-repeat bgi-size-cover bgi-position-x-center bgi-position-y-bottom landing-light-bg'>
      <div className='container'>
        <div className='row gx-4 mb-12 mx-auto text-center'>
          <div className=' mb-4 blob'></div>

          <h3 className='text-center fs-2x fs-lg-2x'>
            Our Numbers as at Today
          </h3>
          <div className='col-xl-4 col-sm-12 g-4'>
            <div className='card mx-auto'>
              <div className='card-body'>
                <img
                  src={Resellers}
                  width='32px'
                  height='32px'
                  alt='resellers'
                />

                <div className='fw-bold counted cardtext display-5 mb-2 mt-5'>
                  {count}
                </div>
                <div className='fw-bold cardtext '>
                  Total Number of Resellers
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-sm-12 g-4'>
            <div className='card '>
              <div className='card-body'>
                <img
                  src={BrandIcon}
                  width='32px'
                  height='32px'
                  alt='brandicon'
                />

                <div className='cardtext fw-bold display-5 mb-2 mt-5'>
                  {count1}
                </div>
                <div className='fw-bold cardtext'>Total Brands</div>
              </div>
            </div>
          </div>
          <div className='col-xl-4 col-sm-12 g-4'>
            <div className='card '>
              <div className='card-body'>
                <img src={Product} width='32px' height='32px' alt='product' />

                <div className='cardtext fw-bold display-5 mb-2 mt-5'>
                  {count2}
                </div>
                <div className='fw-bold cardtext'>Total Products</div>
              </div>
            </div>

            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section1;
